module.exports = __webpack_public_path__ + "r-v3/img/emoti-star.3cd8f96d.svg";